export function setParamsContacts(state, filter) {
    state.params_contacts.filter = filter;
}
export function setLines(state, lines) {
    state.lines = lines;
}
export function setBrands(state, brands) {
    state.brands = brands;
}
export function setPriceLists(state, price_lists) {
    state.price_lists = price_lists;
}
export function setDiscount(state, discount) {
    state.discount = discount;
    state.params = {
        id: discount.id,
        price_list_id: discount.price_list_id,
        contact_id: discount.contact_id,
        brand_id: discount.brand_id,
        discount_percentage: discount.discount_percentage,
        line_id: discount.line_id,
        products: discount.products && discount.products.length > 0 ? discount.products.map(product => product.id) : []
    };
}
export function setDiscounts(state, discounts) {
    state.discounts = discounts;
}
export function setContacts(state, data) {
    state.contacts = data;
}

export function resetFields(state) {
    state.params = {
        price_list_id: null,
        contact_id: null,
        brand_id: null,
        line_id: null,
        discount_percentage: null,
        products: []
    };
}

export function setloading(state, value) {
    state.loading.module = value;
}
export function setFile(state, value) {
    state.file = value;
}

export function setPerPage(state, perPage) {
    state.params.page = 1;
    state.params.perPage = perPage;
}

export function setPage(state, page) {
    state.params.page = page;
}

export function setUploadFileButton(state) {
    state.upload_file = !state.upload_file;
}

export function setProducts (state, products) {
    state.products = products;
}

export function setPreloader(state, preloader) {
    state.preloader = preloader;
}

export function setParamsProductReset (state) {
    state.params.products = [];
}



// WEBPACK FOOTER //
// ./src/modules/customerDiscountBrand/mutations.js